module.exports = __webpack_public_path__ + "img/m-capitalchain.a42c0cb8.png";